import React from "react"

import { MenuDropdownElement } from "../../../elements/menuDropdown.element"
import { MenuItemElement } from "../../../elements/menuItem.element"
import type { IMenuItem } from "../../../types/objects.types"
import type { IMenuProps } from "../../../types/props.types"

export const DesktopMenuComponent: React.FunctionComponent<
    IMenuProps
> = props => {
    return (
        <div className={`flex items-center md:hidden ${props.className}`}>
            {props.menuItems.map((item: IMenuItem, index: number) => {
                const hasSubmenu = !!item.submenu
                const hasSubmenuItems = (item.submenu?.length ?? 0) > 0

                return hasSubmenu ? (
                    hasSubmenuItems ? (
                        <MenuDropdownElement
                            key={index}
                            className={`
                                ${
                                    index !== props.menuItems.length - 1
                                        ? "mr-[32px]"
                                        : ""
                                }
                            `}
                            label={item.label}
                            items={item.submenu || []}
                        />
                    ) : null
                ) : (
                    <MenuItemElement
                        key={index}
                        item={item}
                        className={
                            index !== props.menuItems.length - 1
                                ? "mr-[32px]"
                                : undefined
                        }
                        typography="text"
                        activeTypography="textBold"
                        centered
                        floatingComingSoon
                    />
                )
            })}
        </div>
    )
}
